import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'
import {destandard} from "../utils/commonFunctions";

export const getHomePage = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  dispatch({type: 'GET_HOMEPAGE_TILES_PENDING'});
  return irelandApi.get('/api/home_page')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: {data: response.data.data.attributes.carousel}});
      dispatch({type: 'GET_HOMEPAGE_TILES_FULFILLED', payLoad: {data: response.data.data.attributes.tiles}});
      dispatch({type: 'SET_CAROUSEL_SPEED', payLoad: response.data.data.attributes.carousel_speed});
    })
    .catch((error) => {
    })
};

export const getCarousels = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_PENDING'});
  return irelandApi.get('/api/admin/home_page_carousel')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_REJECTED', payLoad: error.data})
    })
};

export const getCarouselsSetting = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_CAROUSELS_SETTING_PENDING'});
  return irelandApi.get('/api/admin/home_page_carousel_setting')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_SETTING_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_CAROUSELS_SETTING_REJECTED', payLoad: error.data})
    })
};

export const updateCarousels = (payload) => {
  const data = {
    home_page_carousel: {...payload}
  };

  return irelandApi.patch('/api/admin/home_page_carousel/change_position_live', data)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousels has been saved successfully"/>);
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      for (var p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={data[p]}/>);
        }
      }
    })
};

export const updateCarousel = (id, payload) => {
  const mPayLoad = {
    ...payload,
    permission_ids: []
  };
  var notempty = false;
  Object.keys(payload.permission_ids).forEach(function (key) {
    if (payload.permission_ids[key].checked) {
      mPayLoad.permission_ids.push(+key);
      notempty = true;
    }
  });
  if (notempty == false) {
    mPayLoad.permission_ids.push('');
  }
  mPayLoad['group_ids'] = mPayLoad.group_ids.map(curr => curr.value) || []
  if (mPayLoad["group_ids"].includes("all")) {
    mPayLoad["all_groups"] = true;
    delete mPayLoad["group_ids"];
  }

  if (mPayLoad["group_ids"] && mPayLoad["group_ids"].length === 0) {
    mPayLoad["all_groups"] = false;
    mPayLoad["group_ids"] = [];
  }

  let formData = buildCarouselFormData(mPayLoad);
  
  return irelandApi.patch(`/api/admin/home_page_carousel/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been updated successfully"/>);
      history.push('/admin/homepage#carousel');
    })
    .catch((error) => {
      const data = {
        ...error.response.data
      };
      for (var p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={p + ' : ' + data[p]}/>);
        }
      }
    })
};

export const CreateCarousel = (payload) => {
  const mPayLoad = {
    ...payload,
    permission_ids: []
  };
  var notempty = false;
  Object.keys(payload.permission_ids).forEach(function (key) {
    if (payload.permission_ids[key].checked) {
      mPayLoad.permission_ids.push(+key);
      notempty = true;
    }
  });
  if (notempty == false) {
    mPayLoad.permission_ids.push('');
  }

  mPayLoad['group_ids'] = mPayLoad.group_ids.map(curr => curr.value) || []
  if (mPayLoad["group_ids"].includes("all")) {
    mPayLoad["all_groups"] = true;
    delete mPayLoad["group_ids"];
  }

  if (mPayLoad["group_ids"] && mPayLoad["group_ids"].length === 0) {
    mPayLoad["all_groups"] = false;
    mPayLoad["group_ids"] = [];
  }

  let formData = buildCarouselFormData(mPayLoad);
  
  return irelandApi.post('/api/admin/home_page_carousel', formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been created successfully"/>);
      history.push('/admin/homepage#carousel');
    })
    .catch((error) => {
      const data = {
        ...error.response.data
      };
      for (var p in data) {
        if (data.hasOwnProperty(p)) {
          toast.success(<ToastMessage iconStyle="error" message={p + ' : ' + data[p]}/>);
        }
      }
    })
};

export const deleteCarousel = (id) => (dispatch) => {
  dispatch({type: "DELETE_CAROUSEL_PENDING"});
  return irelandApi.delete(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Carousel has been deleted successfully"/>);
      dispatch({type: "DELETE_CAROUSEL_FULFILLED", payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete Carousel"/>);
      dispatch({type: 'DELETE_CAROUSEL_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    })
};

export const getcarousel = (id) => (dispatch) => {
  dispatch({type: "GET_CAROUSEL_PENDING"});
  return irelandApi.get(`/api/admin/home_page_carousel/${id}`)
    .then((response) => {
      const data = destandard({
        ...response.data.data.attributes
      });
      dispatch({type: "GET_CAROUSEL_FULFILLED", payLoad: data});
      store.dispatch(actions.load('deep.home_page_carousel', data));
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={`Unable to get carousel.`}/>, {autoClose: 2000});
      dispatch({type: 'GET_CAROUSEL_REJECTED', payLoad: "error"})
    })
};

export const updateCarouselsSetting = (payload) => {
  const data = {
    slide_speed: payload
  };
  return irelandApi.patch('/api/admin/home_page_carousel_setting', data)
    .then((response) => {
    })
    .catch((error) => {
      toast.success(<ToastMessage iconStyle="error" message="Slider setting has not been saved successfully"/>);
    })
};

export const getTiles = () => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_TILES_PENDING'});
  return irelandApi
    .get('/api/admin/homepage_tile')
    .then((response) => {
      dispatch({type: 'GET_HOMEPAGE_TILES_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_TILES_REJECTED', payLoad: error.data})
    })
};

export const getTile = (id) => (dispatch) => {
  dispatch({type: 'GET_HOMEPAGE_TILE_PENDING'});
  return irelandApi
    .get(`/api/admin/homepage_tile/${id}`)
    .then((response) => {
      let attributes = response.data.data.attributes;
      dispatch(actions.load('deep.tile', {
        "link": attributes['button-link'],
        "label": attributes['button-label'],
        "button_color": attributes['button-color'],
      }));
      dispatch({type: 'GET_HOMEPAGE_TILE_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_HOMEPAGE_TILE_REJECTED', payLoad: error.data})
    })
};

export const updateTiles = (payLoad, id, kind) => {
  let formData = new FormData();
  let tile;
  if (kind === 'static') {
    tile = {};
    if (payLoad.image !== undefined)
      tile.image = payLoad.image;
    tile.button_color = payLoad.button_color;
  } else {
    tile = payLoad;
  }
  Object
    .keys(tile)
    .forEach(key => {
      if (key !== "label" && key !== "link") {
        formData.append(`homepage_tile[${key}]`, tile[key])
      }
    });
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return irelandApi
    .patch(`/api/admin/homepage_tile/${id}`, formData, config)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Tile has been saved successfully"/>);
      history.push('/admin/homepage#tiles');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save tile"/>);
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const getGroups = () => (dispatch) => {
  dispatch({ type: "GET_GROUPS_LIST_PENDING" });

  return irelandApi.get(`/api/admin/home_page_carousel/new`)
    .then((response) => {
      dispatch({ type: "GET_GROUPS_LIST_FULFILLED", payLoad: response.data.meta });
    })
    .catch((error) => {
      dispatch({ type: 'GET_GROUPS_LIST_REJECTED', payLoad: error.data })
    })
};

const buildCarouselFormData = (data) => {
  let formData = new FormData();

  Object.keys(data).forEach(key => {
      if (Array.isArray(data[key])) {
        var arrayLength = data[key].length;
        for (var i = 0; i < arrayLength; i++) {
          formData.append(`home_page_carousel[${key}][]`, data[key][i])
        }
        if(key === 'group_ids' && !data[key].length) {
          formData.append(`home_page_carousel[${key}][]`, [])
        }
      } else {
        if(data[key] && data[key].constructor == Object) {
          const nestedFields = Object.entries(data[key]);
          for (const [fieldName, fieldData] of nestedFields) {
            formData.append(`home_page_carousel[${key}][${fieldName}]`, fieldData);
          }
        } else {
          formData.append(`home_page_carousel[${key}]`, data[key])
        }
      }
  });

  return formData;
}




// WEBPACK FOOTER //
// ./src/actions/home.js